import React, { useState, useEffect } from 'react';
import { Grid, Fab } from '@mui/material';
import SwipeUpIcon from '@mui/icons-material/SwipeUp';

export const BtnSubir = () => {
    const [visible, setVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 100) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    return (
        <Grid
            container
            direction="row"
            justifyContent="end"
            alignItems="center"
            sx={{
                position: 'fixed',
                bottom: 16,
                right: 16,
                zIndex: 1000,
                opacity: visible ? 1 : 0,
                transition: 'opacity 0.3s'
            }}
            className='fade-in'
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
            <Fab
                size="medium"
                color="primary"
                aria-label="Subir"

            >
                <SwipeUpIcon />
            </Fab>
        </Grid>
    );
};